import { ButtonHTMLAttributes, ReactNode } from 'react';
import '../styles/Button.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'outline';
  size?: 'small' | 'medium' | 'large';
}

export function Button({
  children,
  variant = 'primary',
  size = 'medium',
  className = '',
  ...props
}: ButtonProps) {
  const classNames = ['btn', `btn-${variant}`, `btn-${size}`, className].join(
    ' '
  );

  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
}
